import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from '@/context/CartContext';
import { AuthProvider } from '@/context/AuthContext';
import Layout from '@/components/layout/Layout';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import Home from '@/pages/Home';
import Catalog from '@/pages/Catalog';
import ProductDetail from '@/pages/ProductDetail';
import Checkout from '@/pages/Checkout';
import Questionnaire from '@/pages/Questionnaire';
import Brands, { BrandDetail } from '@/pages/Brands';
import OrderConfirmation from '@/pages/OrderConfirmation';
import PaymentResult from '@/pages/PaymentResult';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import OrderTracking from '@/pages/OrderTracking';
import ReviewSubmit from '@/pages/ReviewSubmit';
import MyOrders from '@/pages/MyOrders';
import AdminHome from '@/pages/AdminHome';
import AdminImages from '@/pages/AdminImages';
import AdminOrders from '@/pages/AdminOrders';
import AdminProducts from '@/pages/AdminProducts';
import AdminShipping from '@/pages/AdminShipping';
import AdminPayments from '@/pages/AdminPayments';
import AdminCoupons from '@/pages/AdminCoupons';
import AdminReviews from '@/pages/AdminReviews';
import AdminAbandonedCarts from '@/pages/AdminAbandonedCarts';
import { About, FAQ, Contact, OffersPage, SearchResults } from '@/pages/StaticPages';
import { Terms, Privacy, DataTreatment, ShippingPolicy, Returns } from '@/pages/LegalPages';
import NotFound from '@/pages/NotFound';
import '@/index.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/perros" element={<Catalog species="perro" />} />
              <Route path="/gatos" element={<Catalog species="gato" />} />
              <Route path="/producto/:slug" element={<ProductDetail />} />
              <Route path="/marcas" element={<Brands />} />
              <Route path="/marcas/:slug" element={<BrandDetail />} />
              <Route path="/encuentra-alimento" element={<Questionnaire />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orden-confirmacion/:orderNumber" element={<OrderConfirmation />} />
              <Route path="/pago-resultado" element={<PaymentResult />} />
              <Route path="/rastreo/:orderNumber" element={<OrderTracking />} />
              <Route path="/resena/:orderNumber" element={<ReviewSubmit />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registro" element={<Register />} />
              <Route path="/recuperar-contrasena" element={<ForgotPassword />} />
              <Route path="/restablecer-contrasena" element={<ResetPassword />} />
              <Route path="/mis-pedidos" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminHome />} />
              <Route path="/admin/pedidos" element={<AdminOrders />} />
              <Route path="/admin/productos" element={<AdminProducts />} />
              <Route path="/admin/pagos" element={<AdminPayments />} />
              <Route path="/admin/cupones" element={<AdminCoupons />} />
              <Route path="/admin/resenas" element={<AdminReviews />} />
              <Route path="/admin/carritos-abandonados" element={<AdminAbandonedCarts />} />
              <Route path="/admin/envios" element={<AdminShipping />} />
              <Route path="/admin/imagenes" element={<AdminImages />} />
              <Route path="/ofertas" element={<OffersPage />} />
              <Route path="/nosotros" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/buscar" element={<SearchResults />} />
              {/* Legal pages */}
              <Route path="/terminos" element={<Terms />} />
              <Route path="/privacidad" element={<Privacy />} />
              <Route path="/tratamiento-datos" element={<DataTreatment />} />
              <Route path="/envios" element={<ShippingPolicy />} />
              <Route path="/cambios-devoluciones" element={<Returns />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
